const translations = {
  page_title: 'Custom Makes & Models',
  section_description: 'These are makes and models manually added to the database.',
  add_new_make: 'Add Make & Model',

  make: 'Make',
  make_name: 'Make name',
  model: 'Model',
  model_name: 'Model name',
  year: 'Year',
  enter_year: 'Enter year',
  make_added: 'Make and model added successfully',
  add_make: 'Add make',
  add_model: 'Add model',
  please_enter_name: 'Please enter name',

  add_years: 'Add years'
};

export default translations;
